import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import styled from 'styled-components';
import tw from 'twin.macro';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useParams } from 'react-router-dom';

const Container = styled.div`
  ${tw`w-full h-screen`}
`;

const PDFViewer = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const params = useParams();
  const carId = params.carId;

  return (
    <Container>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
        <Viewer fileUrl={`/carfax/${carId}.pdf`} plugins={[defaultLayoutPluginInstance]} />
      </Worker>
    </Container>
  );
};

export default PDFViewer;
